import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import Logout from '../logout'
import Activation from '../login/activation'
import Navbar from './navbar'
import { withRouter } from 'react-router'
import JoyrideProvider from './joyrideProvider';
import { Notifs } from 'redux-notifications';

import 'react-joyride/lib/react-joyride-compiled.css';
import './redux-notifications.css'

class Connected extends Component {
  render() {
    return (
        <JoyrideProvider>
          <div>
            <Notifs />
            <Route path="/" component={Navbar} />
            <Route extact path="/login" render={ (props) => <Redirect to="/" />} />
            <Route extact path="/logout" component={Logout} />
            <Route exact path="/accountValidation/:userId/:activationKey" component={Activation} />
          </div>
        </JoyrideProvider>
    )
  }
}

Connected.propTypes = {
  dispatch: PropTypes.func.isRequired
}


function mapStateToProps(state) {

  const { routing, joyride } = state

  return {
    routing,
    joyride
  }
}

export default withRouter(connect(mapStateToProps)(Connected))



// WEBPACK FOOTER //
// ./src/containers/app/connected.js